import React, { useState } from "react";
import Modal from "components/UI/DialogModal";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import MuiButton from "components/UI/MuiButton";
import { useTranslation } from "react-i18next";
import { IJob } from "models/job";
import { useAlert } from "contexts/alertContext";
import DeleteIcon from "@mui/icons-material/Delete";
import { ICompanyJob } from "models/companyJob";
import { ICompanyDepartments } from "models/companyDepartment";


type Entry = {
  name: string;
  nameAr: string;
};


interface Props {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onSubmit: (data: Entry[]) => void;
}




const AddCorporateTopics: React.FC<Props> = ({
  open,
  loading,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  
  const [title, setTitle] = useState<string>("");
  const [titleAr, setTitleAr] = useState<string>("");
  const [entries, setEntries] = useState<Entry[]>([]);
  const { setAlert } = useAlert();


  const handleAddEntry = () => {
    
        const newEntry = {  name: title, nameAr: titleAr };
        setEntries([...entries, newEntry]);
        setTitle("");
        setTitleAr("");
     
    

    

  };

  const handleDeleteEntry = (index: number) => {
    const newEntries = entries.filter((_, i) => i !== index);
    setEntries(newEntries);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={t("T_add_topic")}
        maxWidth="lg"
        children={
          <Stack spacing={2} p={2}>

            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >

                <TextField
                  label={t("T_title")}
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />

                <TextField
                  label={t("T_title_Ar")}
                  value={titleAr}
                  onChange={(e) => setTitleAr(e.target.value)}
                />
                <Button
                  variant="contained"
                  style={{ borderRadius: 0 }}
                  onClick={handleAddEntry}
                  disabled={!title || !titleAr}
                >
                  {t("T_add")}
                </Button>
              </div>

              <Table>
                <TableHead>
                  <TableRow>
                  
                    <TableCell>{t("T_title")}</TableCell>
                    <TableCell>{t("T_title_Ar")}</TableCell>
                    <TableCell>{t("T_action")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {entries.map((entry, index) => (
                    <TableRow key={index}>
                      <TableCell>{entry.name}</TableCell>
                      <TableCell>{entry.nameAr}</TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleDeleteEntry(index)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Stack>
        }
        actions={
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
            px={1}
          >
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "warning.main", color: "white" }}
              size="large"
              onClick={onClose}
            >
              {t("T_cancel")}
            </MuiButton>
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "primary.main", color: "white" }}
              disabled={loading}
              size="large"
              onClick={() => onSubmit(entries)}
            >
              {t("T_add")}
              <CircularProgress
                size={10}
                sx={{ mx: 2, display: loading ? "" : "none" }}
              />
            </MuiButton>
          </Grid>
        }
      />
    </>
  );
};

export default AddCorporateTopics;
